import {
  HOST_SLAVE_FEATURE_ID,
  FOODY_INTEGRATION_FEATURE_ID,
  AUTO_ACCEPT_FOODY_ORDERS_FEATURE_ID,
  E_PAYMENT_FEATURE_ID,
  ASSEMBLED_ORDER_LOADING_IN_REPORT_FEATURE_ID, NEW_MENU_SERVICE_ID,
} from './utils'

export const functionSwitchFrontendPath = '/advanced_function/function_switch';
export const functionSwitchBackendPath = '/backend/advanced_function/setting/feature/get/';

export const baseUrlFunctionSwitch = '/advanced_function/functions_switch';

export const functionSwitchHotSlaveFrontendPath = `/advanced_function/functions_switch/${HOST_SLAVE_FEATURE_ID}`;
export const functionSwitchHotSlaveBackendPath = `/backend/advanced_function/shop/setting/feature/search/${HOST_SLAVE_FEATURE_ID}`;

export const functionSwitchFoodyIntegrationFrontendPath = `/advanced_function/functions_switch/${FOODY_INTEGRATION_FEATURE_ID}`;
export const functionSwitchFoodyIntegrationBackendPath = `/backend/advanced_function/shop/setting/feature/search/${FOODY_INTEGRATION_FEATURE_ID}`;

export const functionSwitchAutoAcceptFoodyOrdersFrontendPath = `/advanced_function/functions_switch/${AUTO_ACCEPT_FOODY_ORDERS_FEATURE_ID}`;
export const functionSwitchAutoAcceptFoodyOrdersBackendPath = `/backend/advanced_function/shop/setting/feature/search/${AUTO_ACCEPT_FOODY_ORDERS_FEATURE_ID}`;

export const functionSwitchEpaymentFrontendPath = `/advanced_function/functions_switch/${E_PAYMENT_FEATURE_ID}`;
export const functionSwitchEpaymentBackendPath = `/backend/advanced_function/shop/setting/feature/search/${E_PAYMENT_FEATURE_ID}`;

export const functionSwitchAssembledOrderLoadingInReportFrontendPath = `/advanced_function/functions_switch/${ASSEMBLED_ORDER_LOADING_IN_REPORT_FEATURE_ID}`;
export const functionSwitchAssembledOrderLoadingInReportBackendPath = `/backend/advanced_function/shop/setting/feature/search/${ASSEMBLED_ORDER_LOADING_IN_REPORT_FEATURE_ID}`;

export const functionSwitchNewMenuServiceFrontendPath = `/advanced_function/functions_switch/${NEW_MENU_SERVICE_ID}`;
export const functionSwitchNewMenuServiceBackendPath = `/backend/advanced_function/shop/setting/feature/search/${NEW_MENU_SERVICE_ID}`;

export const functionSwitchAddWhitelistFrontendPath = `/advanced_function/functions_switch/:feature/add`;

export const functionSwitchRemoveWhitelistFrontendPath = `/advanced_function/functions_switch/:feature/remove/`;
export const functionSwitchEditWhitelistFrontendPath = `/advanced_function/functions_switch/:feature/edit/`;

export const premiumShopFrontendPath = '/advanced_function/premium_shop';
export const premiumShopBackendPath = '/backend/advanced_function/shop/search/';

export const premiumShopGetChainShopListBackendPath = '/backend/advanced_function/chain/shop/get/';

export const premiumShopUnmergeBranchFrontendPath = '/advanced_function/premium_shop/unmerge_branch';
export const premiumShopUnmergeBranchBackendPath = '/backend/advanced_function/chain/unmerge/';

export const premiumShopTransferPrimaryFrontendPath = '/advanced_function/premium_shop/transfer_primary';
export const premiumShopTransferPrimaryBackendPath = '/backend/advanced_function/chain/primary/transfer/';

export const premiumShopDeactivateFrontendPath = '/advanced_function/premium_shop/deactivate';
export const premiumShopDeactivateBackendPath = '/backend/advanced_function/chain/deactivate/';

export const importFoodyMenuFrontendPath = '/advanced_function/import_foody_menu';
export const importFoodyMenuBackendPath = '/backend/advanced_function/foody/menu/import/';

export const extendMembershipFrontendPath = '/advanced_function/extend_membership';
export const extendMembershipBackenddPath = '/backend/advanced_function/chain/shop/member/get/';

export const extendMembershipUpdateFrontendPath = '/advanced_function/extend_membership/update';
export const extendMembershipUpdateBackenddPath = '/backend/advanced_function/chain/shop/member/update/';

export const nowOchaShopsFrontendPath = '/advanced_function/now_ocha_shops';
export const nowOchaShopsBackendPath = '/backend/advanced_function/foody/account/link/search/';

export const nowOchaShopsChangeDeliveryFrontendPath = '/advanced_function/now_ocha_shops/change_delivery_status';
export const nowOchaShopsChangeDeliveryBackendPath = ' /backend/advanced_function/foody/restaurant/status/update/';

export const reminderConfigFrontendPath = '/advanced_function/reminder_config/';
export const reminderConfigBackendPath = '/backend/advanced_function/client/release/info/';
export const reminderConfigEditBackendPath = '/backend/advanced_function/client/release/info/update';
export const reminderConfigMinDropEditBackendPath = '/backend/advanced_function/min_client_version/update';
export const reminderConfigUpdateDetailFrontendPath = '/advanced_function/reminder_config/:id/update/detail/';
export const reminderConfigUpdateEditFrontendPath = '/advanced_function/reminder_config/:id/update/';
export const reminderConfigDropDetailFrontendPath = '/advanced_function/reminder_config/:id/drop/detail/';
export const reminderConfigDropEditFrontendPath = '/advanced_function/reminder_config/:id/drop/';

export const dualScreenAdListFrontendPath = '/advanced_function/dual_screen_ad/';
export const dualScreenAdListBackendPath = '/backend/advanced_function/dual_screen/ad/'
export const dualScreenAdEditFrontendPath = '/advanced_function/dual_screen_ad/edit/:id';
export const dualScreenAdEditBackendPath = '/backend/advanced_function/dual_screen/ad/edit/';
export const dualScreenAdDetailFrontendPath = '/advanced_function/dual_screen_ad/:id/detail';
export const dualScreenAdDetailBackendPath = '/backend/advanced_function/dual_screen/ad/detail/';
export const dualScreenAdCreateBackendPath = '/backend/advanced_function/dual_screen/ad/create/';



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/urls.js